import { Box } from "@primer/react";
import moment from "moment";
import PreviewableAvatar from "../hocsinh-avatar-preview/PreviewableAvatar";

interface IHocSinhShortInfoProps {
  data: any;
  onClick?: (data: any) => void;
}
const HocSinhShortInfo = (props: IHocSinhShortInfoProps) => {
  const { data, onClick } = props;

  const handleClick = () => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <Box
      sx={{ display: "flex", cursor: onClick ? "pointer" : "default" }}
      onClick={handleClick}
    >
      <Box sx={{ mr: 2, mt: 1 }}>
        <PreviewableAvatar
          avatarUrl={data.avatar}
          fullName={data.ho_ten}
          size="large"
        />
      </Box>
      <Box sx={{ display: "grid", flex: 1 }}>
        <Box
          sx={{
            fontWeight: 600,
            color: onClick ? "#133E87" : "inherit",
            "&:hover": onClick ? { textDecoration: "underline" } : {},
          }}
        >
          {data.ho_ten}
        </Box>
        <Box sx={{ color: "fg.muted" }}>
          {data.ngay_sinh &&
            moment(data.ngay_sinh).isValid() &&
            !data.ngay_sinh.startsWith("0001-01-01")
            ? moment(data.ngay_sinh).format("DD/MM/YYYY")
            : ""}
        </Box>
      </Box>
    </Box>
  );
};

export default HocSinhShortInfo;
